// extracted by mini-css-extract-plugin
export default {"image-container":"image-container--3Gg11","imageContainer":"image-container--3Gg11"};